module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template.id == null) ? _c('div', {
    staticClass: "lable text-center"
  }, [_vm._v(_vm._s(_vm.$t('template.label.selectTemplate')))]) : _vm._e(), _c('div', {
    staticClass: "row",
    class: {
      'template-modal': _vm.element_options.modal
    },
    attrs: {
      "id": "template-types-menu"
    }
  }, [_c('div', {
    staticClass: "template-type email",
    class: {
      active: _vm.template_kind == "email", inactive: _vm.inactive("email")
    },
    on: {
      "click": function($event) {
        return _vm.changeTemplateType("email")
      }
    }
  }), _c('div', {
    staticClass: "template-type phonecall",
    class: {
      active: _vm.template_kind == "phonecall", inactive: _vm.inactive("phonecall")
    },
    on: {
      "click": function($event) {
        return _vm.changeTemplateType("phonecall")
      }
    }
  }), _c('div', {
    staticClass: "template-type linkedin",
    class: {
      active: _vm.template_kind == "linkedin", inactive: _vm.inactive("linkedin")
    },
    on: {
      "click": function($event) {
        return _vm.changeTemplateType("linkedin")
      }
    }
  }), _c('div', {
    staticClass: "template-type social",
    class: {
      active: _vm.template_kind == "social", inactive: _vm.inactive("social")
    },
    on: {
      "click": function($event) {
        return _vm.changeTemplateType("social")
      }
    }
  }), (!_vm.element_options.modal) ? _c('div', {
    staticClass: "template-type library",
    class: {
      active: _vm.template_kind == "library", inactive: _vm.inactive("library")
    },
    on: {
      "click": function($event) {
        return _vm.changeTemplateType("library")
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "row form-wrapper",
    class: [{
      'template-modal': _vm.element_options.modal
    }, _vm.template_kind]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.template_kind == "library"),
      expression: "template_kind == \"library\""
    }],
    staticClass: "col-sm-12"
  }, [_c('list', {
    attrs: {
      "options": _vm.list_options,
      "list_item_options": _vm.list_item_options,
      "filter_options": _vm.filter_options
    },
    on: {
      "template-selected": _vm.fillForm
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.template_kind != "library"),
      expression: "template_kind != \"library\""
    }],
    class: [{
      'template-modal-form': _vm.element_options.modal,
    }, _vm.template_kind],
    attrs: {
      "id": _vm.id
    }
  }, [_c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.apiErrorMessages.length),
      expression: "apiErrorMessages.length"
    }],
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.apiErrorMessages), function(errorMessage) {
    return _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(errorMessage))])
  }), 0), (_vm.show_responsible_dropdown) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.element_options.name != 'hide') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.nameLabel()))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name),
      expression: "template.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text",
      "disabled": _vm.element_options.name == 'disabled'
    },
    domProps: {
      "value": (_vm.template.name)
    },
    on: {
      "change": _vm.setDirty,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    key: "name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1)]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [(_vm.element_options.category != 'hide') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('template_category_id')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "template_category_id"
    }
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.category')))]), _c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    attrs: {
      "options": _vm.template_category_options,
      "selected": _vm.template.template_category_id,
      "data-vv-name": "template_category_id",
      "disabled": _vm.element_options.category == 'disabled'
    },
    on: {
      "input": _vm.setDirty
    },
    model: {
      value: (_vm.template.template_category_id),
      callback: function($$v) {
        _vm.$set(_vm.template, "template_category_id", $$v)
      },
      expression: "template.template_category_id"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('template_category_id')),
      expression: "errors.has('template_category_id')"
    }],
    key: "template_category_id",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('template_category_id')))])])], 1)]) : _vm._e(), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "user_id"
    }
  }, [_vm._v(_vm._s(_vm.$t('template.attribute.user')))]), _c('dropdown-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "field",
    attrs: {
      "options": _vm.template_user_options,
      "selected": _vm.template.user_id,
      "data-vv-name": "template_user_id",
      "disabled": _vm.element_options.responsible == "disabled"
    },
    on: {
      "change": _vm.setDirty
    },
    model: {
      value: (_vm.template.user_id),
      callback: function($$v) {
        _vm.$set(_vm.template, "user_id", $$v)
      },
      expression: "template.user_id"
    }
  })], 1)])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.element_options.name != 'hide') ? _c('div', {
    class: {
      'col-md-12': _vm.template_kind == 'linkedin', 'col-md-6': _vm.template_kind != 'linkedin'
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.nameLabel()))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name),
      expression: "template.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text",
      "disabled": _vm.element_options.name == 'disabled'
    },
    domProps: {
      "value": (_vm.template.name)
    },
    on: {
      "change": _vm.setDirty,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    key: "name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1)]) : _vm._e(), (_vm.element_options.category != 'hide') ? _c('div', {
    class: {
      'col-md-12': _vm.template_kind == 'linkedin', 'col-md-6': _vm.template_kind != 'linkedin'
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('template_category_id')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "template_category_id"
    }
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.category')))]), _c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "options": _vm.template_category_options,
      "selected": _vm.template.template_category_id,
      "data-vv-name": "template_category_id",
      "disabled": _vm.element_options.category == 'disabled'
    },
    on: {
      "input": _vm.setDirty
    },
    model: {
      value: (_vm.template.template_category_id),
      callback: function($$v) {
        _vm.$set(_vm.template, "template_category_id", $$v)
      },
      expression: "template.template_category_id"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('template_category_id')),
      expression: "errors.has('template_category_id')"
    }],
    key: "template_category_id",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('template_category_id')))])])], 1)]) : _vm._e()]), (_vm.template_kind == 'email') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.subject_group_class
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "subject"
    }
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.subject')))]), _c('variables-dropdown', {
    attrs: {
      "variables": _vm.variables
    },
    on: {
      "add-variable": _vm.addVariableToSubject
    }
  }), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.template.subject),
      expression: "template.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "subject",
      "type": "text"
    },
    domProps: {
      "value": (_vm.template.subject)
    },
    on: {
      "blur": _vm.updateLastSubjectCursorPosition,
      "change": _vm.setDirty,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "subject", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subject_help_text),
      expression: "subject_help_text"
    }],
    key: "subject",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.subject_help_text))])])], 1)])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('body')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v(_vm._s(_vm.contentLabel()))]), _c('variables-dropdown', {
    attrs: {
      "variables": _vm.variables
    },
    on: {
      "add-variable": _vm.addVariableToBody
    },
    nativeOn: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.saveSummernoteRange.apply(null, arguments)
      }
    }
  }), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "body",
    attrs: {
      "name": "body"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('body')),
      expression: "errors.has('body')"
    }],
    key: "body",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('body')))])])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.template_kind == 'email'),
      expression: "template_kind == 'email'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('signature')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "signature"
    }
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.emailSignature')))]), _c('textarea', {
    staticClass: "signature",
    attrs: {
      "name": "signature"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('signature')),
      expression: "errors.has('signature')"
    }],
    key: "signature",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('signature')))])])], 1)])])], 1), (_vm.element_options.show_footer) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.template_kind != "library") ? _c('div', {
    staticClass: "wrapper-buttons text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "to": "/templates"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disabledBnt || _vm.current_user.isMonitoringManager()
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.template.id ? _vm.$t('general.actions.saveWithLabel', {
    label: _vm.buttonLabel()
  }) : _vm.$t('general.actions.createWithLabel', {
    label: _vm.buttonLabel()
  })))])], 1) : _vm._e()])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "clearfix"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7074d966!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/form.vue
// module id = 1164
// module chunks = 1